<template>
    <el-checkbox-group v-model="checkedCategoryList">
    <div class="category-order">
        <div class="categoryGroup-div"  v-for="(group, groupIndex) in orderDisplay" :key="group.id">
            {{ groupIndex + 1 }}. {{ group.name }}
            <div class="categoryList-div">
                <div class="category-div" :class="getStatusStyle(groupIndex, categoryIndex)"
                 v-for="(item, categoryIndex) in orderDisplay[groupIndex].category" :key="item.id" >
                    <el-checkbox :label="item.id" @change="clickCheckbox(groupIndex, categoryIndex, $event.target.checked)">
                        {{ item.title }}
                    </el-checkbox>
                    <el-button v-if="showUpBtn(groupIndex, categoryIndex)" size="mini" class="el-icon-caret-top category-btn"
                    @click="orderUp(groupIndex, categoryIndex)"></el-button>
                    <el-button v-if="showDownBtn(groupIndex, categoryIndex)" size="mini" class="el-icon-caret-bottom category-btn"
                    @click="orderDown(groupIndex, categoryIndex)"></el-button>
                </div>
            </div>
        </div>
    </div>          
    </el-checkbox-group>
</template>

<script>
import API from '../../api/api';
export default {
    name: 'CategoryOrder',
    props: {
        type: {
            type: String
        },
        categoryGroupList: {
            type: Array
        },
    },
    data() {
        return {
            categoryOrder: [],
            orderDisplay: [],
            checkedCategoryList: [],
        }
    },
    watch: {
        type: {
            immediate: false,
            handler(val) {
                if (this.$store.state.categoryGroupReady) {
                    this.reloadData();
                }
            }
        },
        '$store.state.categoryGroupReady': {
            immediate: true,
            handler(val) {
                if (val) {
                    this.init();
                }
            }
        }
    },
    methods: {
        init() {
            this.reloadData();
        },
        async reloadData() {
            await this.reloadCategoryOrder();
            this.reloadOrderDisplay();
        },
        async reloadCategoryOrder() {
            await API.getCategoryOrder(this.type).then((response) => {
                if(response.status) {
                    redirectLogin(response.data);
                    if(!JSON.parse(response.request.response).error_msg) {
                        this.$message.error('取得分類排序發生錯誤!');
                    } else {
                        this.$message.error(JSON.parse(response.request.response).error_msg);
                    }
                } else {
                    this.categoryOrder = response.result;
                }
            });
        },
        async updateCategoryOrder() {
            let orderData = {
                data: this.categoryOrder
            }
            await API.updateCategoryOrder(this.type, orderData).then((response) => {
                if(response.status) {
                    redirectLogin(response.data);
                    if(!JSON.parse(response.request.response).error_msg) {
                        this.$message.error('更新分類排序發生錯誤!');
                    } else {
                        this.$message.error(JSON.parse(response.request.response).error_msg);
                    }
                } else {
                    this.$store.state.isCategoryUpdated = true;
                }
            });
        },
        reloadOrderDisplay() {
            this.orderDisplay.splice(0);
            this.checkedCategoryList.splice(0);
            for (var orderGroup of this.categoryOrder) {
                // collect el-checkbox-group data
                for (var category of orderGroup.category) {
                    this.checkedCategoryList.push(category.id);
                }
                // process to get category list display on UI
                var categoryDisplay = [];
                for(var categoryGroup of this.categoryGroupList) {
                    if (orderGroup.id === categoryGroup.id) {
                        // get checked category list in order
                        let orderCategory = JSON.parse(JSON.stringify(orderGroup.category));
                        // get unchecked category list
                        let uncheckedList = categoryGroup.category.filter(
                            // find category not in checked category list
                            category => orderCategory.map(c => c.id).indexOf(category.id) < 0);
                        categoryDisplay = [...orderCategory, ...uncheckedList];
                    }
                }
                var data = {
                    id: orderGroup.id,
                    name: orderGroup.name,
                    category: categoryDisplay,
                }
                this.orderDisplay.push(data);
            }
        },
        getCheckedLength(groupIndex) {
            return this.categoryOrder[groupIndex].category.length;
        },
        showUpBtn(groupIndex, categoryIndex) {
            var length = this.getCheckedLength(groupIndex);
            if (length > categoryIndex && categoryIndex != 0) {
                return true;
            }
            return false;
        },
        showDownBtn(groupIndex, categoryIndex) {
            var length = this.getCheckedLength(groupIndex);
            if (length - 1 > categoryIndex) {
                return true;
            }
            return false;
        },
        orderUp(groupIndex, categoryIndex) {
            var item = this.categoryOrder[groupIndex].category[categoryIndex];
            this.categoryOrder[groupIndex].category.splice(categoryIndex , 1);
            this.categoryOrder[groupIndex].category.splice(categoryIndex - 1 , 0, item);
            this.orderDisplay[groupIndex].category.splice(categoryIndex , 1);
            this.orderDisplay[groupIndex].category.splice(categoryIndex - 1 , 0, item);
            this.updateCategoryOrder();
        },
        orderDown(groupIndex, categoryIndex) {
            var item = this.categoryOrder[groupIndex].category[categoryIndex];
            this.categoryOrder[groupIndex].category.splice(categoryIndex , 1);
            this.categoryOrder[groupIndex].category.splice(categoryIndex + 1 , 0, item);
            this.orderDisplay[groupIndex].category.splice(categoryIndex , 1);
            this.orderDisplay[groupIndex].category.splice(categoryIndex + 1 , 0, item);
            this.updateCategoryOrder();
        },
        clickCheckbox(groupIndex, categoryIndex, checked) {
            var item = this.orderDisplay[groupIndex].category[categoryIndex];
            
            this.orderDisplay[groupIndex].category.splice(categoryIndex , 1);
            if (checked) {
                this.categoryOrder[groupIndex].category.push(item);
                this.orderDisplay[groupIndex].category.splice(this.getCheckedLength(groupIndex) - 1, 0, item);
            } else {
                this.categoryOrder[groupIndex].category.splice(categoryIndex , 1);
                this.orderDisplay[groupIndex].category.splice(this.getCheckedLength(groupIndex), 0, item);
            }
            
            this.updateCategoryOrder();
        },
        getStatusStyle(groupIndex, categoryIndex) {
            if (categoryIndex >= this.getCheckedLength(groupIndex)) {
                return "category-div-unchecked";
            }
		    
            return "";
        },
    },
}

</script>

<style lang="scss">
.category-order {
    display: flex;
    flex-flow: row wrap;
    align-items: stretch;
    width: 100%;

    .categoryGroup-div {
        vertical-align: top;
        width: 350px;
        font-size: 16px;
        padding:15px;

        .categoryList-div {
            height: 90%;
            margin-top: 10px;
            padding-top: 1px;
            padding-bottom: 1px;
            background-color: white;

            .category-div {
                margin:10px;
                padding:10px;
                border: 1px solid #EEE;
                font-size: 14px;

                .category-btn {
                    float: right;
                    background-color: transparent;
                    border: none;
                    margin-left: 5px;
                    display: none;
                }
            }

            .category-div:hover {
                color: #2E90F4;
                background: #F0F7FF;
                border: 1px solid #2E90F4;

                .category-btn {
                    display: block;
                }
            }

            .category-div-unchecked {
                background-color: #F9F9F9;
            }
        }
    }
    
}

</style>


// WEBPACK FOOTER //
// CategoryOrder.vue?1fc4eca3